<template>
    <div class="w-full px-30 mx-auto pt-120 lg:(j-w-1180 j-p-0 j-pt-180)">
        <h2 class="work-title">
            <span>{{ t('member_index.guide.title') }}</span>
        </h2>
        <ul class="w-full min-h-736 flex items-center lg:justify-between flex-col lg:flex-row lg:j-min-h-316 bg-white rounded-16 py-60 lg:j-rounded-24 lg:j-py-0 lg:j-px-80 lg:j-gap-x-120">
            <li v-for="({ title, desc, }, index) in list" class="work-step">
                <div class="w-full text-40 leading-65 lg:w-120% lg:j-text-28 lg:j-leading-32 Poppins-SemiBold font-semibold text-black lg:text-sub" v-html="title"></div>
                <p class="text-26 leading-42 lg:j-text-16 lg:j-leading-24 Poppins-Light font-normal text-black/60 lg:text-regular mt-25 lg:j-mt-30" v-html="desc"></p>
                <svg
                    v-if="index + 1 < list.length"
                    class="hidden lg:block lg:j-w-12 lg:j-h-20 lg:absolute -lg:j-right-60 top-1/2"
                    viewBox="0 0 12 20"
                >
                    <path class="fill-primary" d="M3.06,0.52c-0.7-0.68-1.83-0.68-2.53,0s-0.7,1.78,0,2.46l7.3,7.04l-7.3,7.03c-0.7,0.68-0.7,1.78,0,2.46 c0.35,0.34,0.8,0.51,1.27,0.51s0.91-0.17,1.27-0.51c0,0,8.44-8.3,8.49-8.35c0.65-0.63,0.56-1.6,0-2.28 C11.5,8.82,3.06,0.52,3.06,0.52z"/>
                </svg>
            </li>
        </ul>
        <div class="w-full flex-center">
            <span
                class="
                    flex-center border-primary rounded-full text-center text-primary Poppins-SemiBold cursor-pointer
                    lg:j-min-w-172 lg:j-h-48 lg:j-px-32 lg:j-text-18 lg:j-border-2 lg:j-mt-32 hover:bg-primary hover:text-white
                    min-w-248 h-80 px-32 text-28 border-2 mt-50 transition-all duration-300
                "
                @click.prevent="goToGuidePage"
            >{{ t('member_index.guide.learn_more') }}</span>
        </div>
    </div>
</template>
<script setup>
  import { useRouter } from 'vue-router';
  const router = useRouter();
const { t } = useI18n()

const list = [
    {
        title: t('member_index.guide.step_title_1'),
        desc: t('member_index.guide.step_content_1'),
    },
    {
        title: t('member_index.guide.step_title_2'),
        desc: t('member_index.guide.step_content_2'),
    },
    {
        title: t('member_index.guide.step_title_3'),
        desc: t('member_index.guide.step_content_3'),
    },
]

const goToGuidePage = () => {
    router.push({ path: `/index/guide` })
}
</script>
<style scoped>
.work-title {
  @apply
    w-full flex items-start justify-start lg:justify-center text-52 leading-64 lg:j-text-48
    lg:j-leading-48 Poppins-SemiBold font-semibold text-sub p-40 lg:j-p-0 lg:j-mb-40
}
.work-step {
  @apply
    pl-120 pr-90 py-10 lg:j-p-0 relative
    lg:before:hidden before:block before:content-[''] before:absolute before:left-42 before:top-30
    before:w-15 before:h-15 before:bg-primary before:rounded-full before:z-1
    lg:after:hidden after:block after:content-[''] after:absolute after:left-48.5 after:top-30
    after:w-2 after:h-full after:bg-#CCCCCC
}
.work-step:last-of-type {
  @apply
    after:hidden
}
</style>
